import React from 'react';

interface PanelDangerAlertProps {
  title?: string;
}

const PanelDangerAlert: React.FC<PanelDangerAlertProps> = ({ title = "DANGER" }) => {
  return (
    <div className="panel-danger-alert">
      {/* Left stripe box, with its own corners */}
      <div className="stripe-container left">
        <div className="corner top-left" />
        <div className="corner bottom-left" />
        <div className="danger-stripes" />
      </div>

      {/* Central panel with customizable title */}
      <div className="danger-content">
        <div className="horizontal-line top" />
        <span className="danger-text">{title}</span>
        <div className="horizontal-line bottom" />
      </div>

      {/* Right stripe box, with its own corners */}
      <div className="stripe-container right">
        <div className="corner top-right" />
        <div className="corner bottom-right" />
        <div className="danger-stripes" />
      </div>
    </div>
  );
};

export default PanelDangerAlert;
